import React, { useEffect } from 'react';
import BSLALandCharLayers from './landchars/BSLALandCharLayers';
import BSLAWetlandsLayers from './wetlands/BSLAWetlandsLayers';
import BSLAPollutionLayers from './pollution/BSLAPollutionLayers';
import BSLASortLayers from '../helpers/BSLASortLayers';
import BSLASpeciesLayers from './species/BSLASpeciesLayers';

export interface IBSLALayerProps {
    view?: __esri.MapView | __esri.SceneView;
    map?: __esri.Map;
}

const BSLALayers: React.FC<IBSLALayerProps> = (props) => {
    useEffect(() => {
        if (props.map && props.view) {
            const init = async () => {
                if (props.view) {
                    const layers = [];

                    const landCharLayers = await BSLALandCharLayers({ view: props.view });
                    if (landCharLayers) {
                        layers.push(landCharLayers);
                    }

                    const wetlandsLayers = await BSLAWetlandsLayers();
                    if (wetlandsLayers) {
                        layers.push(wetlandsLayers);
                    }

                    const pollutionLayers = await BSLAPollutionLayers();
                    if (pollutionLayers) {
                        layers.push(pollutionLayers);
                    }

                    const speciesLayers = await BSLASpeciesLayers();
                    if (speciesLayers) {
                        layers.push(speciesLayers);
                    }

                    props.map?.addMany(layers.sort(BSLASortLayers));
                }
            };

            init();
        }
    }, [props.map, props.view]);

    return null;
};

export default BSLALayers;
